import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { UserSettingsComponent } from '@go-modules/components/user-settings/user-settings.component';
import { UserDetailsComponent } from '@go-modules/components/user-details/user-details.component';
import { BillingHistoryComponent } from './billing-history/billing-history.component';
import { EmailNotificationsComponent } from '@go-modules/components/user-settings/email-notifications/email-notifications.component';
import { DefaultActivitySettingsModule } from './default-activity-settings/default-activity-settings.module';
import { UnlinkSsoDialogModule } from '@go-modules/components/dialogs/unlink-sso-dialog/unlink-sso-dialog.module';
import { SsoProviderButtonModule } from '@go-modules/components/sso-provider-button/sso-provider-button.module';
import { ChangeEmailDialogModule } from '@go-modules/components/dialogs/change-email-dialog/change-email-dialog.module';
import { ConfirmPasswordDialogModule } from '../dialogs/confirm-password-dialog/confirm-password-dialog.module';
import { ChangePasswordDialogModule } from '../dialogs/change-password-dialog/change-password-dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		ReactiveFormsModule,
		GoSelectModule,
		FormsModule,
		MatTooltipModule,
		DefaultActivitySettingsModule,
		UnlinkSsoDialogModule,
		SsoProviderButtonModule,
		ChangeEmailDialogModule,
		ChangePasswordDialogModule,
		ConfirmPasswordDialogModule
	],
	exports: [
		UserSettingsComponent,
		UserDetailsComponent,
		BillingHistoryComponent,
		EmailNotificationsComponent
	],
	declarations: [
		UserSettingsComponent,
		UserDetailsComponent,
		BillingHistoryComponent,
		EmailNotificationsComponent
	]
})
export class UserSettingsModule {}
